import { render, staticRenderFns } from "./Madcoins.vue?vue&type=template&id=b839411c&"
import script from "./Madcoins.vue?vue&type=script&lang=js&"
export * from "./Madcoins.vue?vue&type=script&lang=js&"
import style0 from "./Madcoins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports